// export enum Races {
//     HUMAN = "HUMAN",
//     WONDERKID = "WONDERKID",
//     ORC = "ORC",
//     DOG = "DOG",
//     WIZARD = "WIZARD",
//     DEVIL = "DEVIL",
//     BULL = "BULL",
//     CELESTIAL = "CELESTIAL",
//     GOAT = "GOAT",
//     HERO = "HERO",
//     SUPER_HERO = "SUPER_HERO",
//     HALFLING = "HALFLING",
//     MERMAID = "MERMAID",
//     MERMAN = "MERMAN",
//     DRAGON = "DRAGON",
//     ELF = "ELF",
//     MACHINE = "MACHINE",
//     GIANT = "GIANT",
//     KNIGHT = "KNIGHT",
//     KING = "KING",
//     DINOSAUR = "DINOSAUR",
//     LION = "LION",
//     DIVINE = "DIVINE",
//     GOLEM = "GOLEM",
//     LIZARD = "LIZARD",
//     WRAITH = "WRAITH",
//     LICH = "LICH",
//     GLADIATOR = "GLADIATOR",
//     CENTURION = "CENTURION",
//     TORCH = "TORCH",
//   }

export const enRaces: { [key: string]: string } = {

    'races.DEVIL': 'Devil',
    'races.ELF': 'Elf',
    'races.ORC': 'Orc',
    'races.HUMAN': 'Human',
    'races.WONDERKID': 'Wonderkid',
    'races.DOG': 'Dog',
    'races.WIZARD': 'Wizard',
    'races.BULL': 'Bull',
    'races.CELESTIAL': 'Celestial',
    'races.GOAT': 'GOAT',
    'races.HERO': 'Hero',
    'races.SUPER_HERO': 'Super Hero',
    'races.HALFLING': 'Halfling',
    'races.MERMAID': 'Mermaid',
    'races.MERMAN': 'Merman',
    'races.DRAGON': 'Dragon',
    'races.MACHINE': 'Machine',
    'races.GIANT': 'Giant',
    'races.KNIGHT': 'Knight',
    'races.KING': 'King',
    'races.DINOSAUR': 'Dinosaur',
    'races.LION': 'Lion',
    'races.DIVINE': 'Divine',
    'races.GOLEM': 'Golem',
    'races.LIZARD': 'Lizard',
    'races.WRAITH': 'Wraith',
    'races.LICH': 'Lich',
    'races.GLADIATOR': 'Gladiator',
    'races.CENTURION': 'Centurion',
    'races.TORCH': 'Torch',
    'races.ICE_MAN': 'Ice Man',

}